import { render } from "./RecentPosts.vue?vue&type=template&id=25095285&scoped=true"
import script from "./RecentPosts.vue?vue&type=script&lang=js"
export * from "./RecentPosts.vue?vue&type=script&lang=js"

import "./RecentPosts.vue?vue&type=style&index=0&id=25095285&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25095285"]])

export default __exports__